(function () {
  if (window.__productMadeToOrderNoticeInit) return;
  window.__productMadeToOrderNoticeInit = true;

  function getInventoryMap(form) {
    var jsonEl = form.querySelector('[data-made-to-order-inventory]');
    if (!jsonEl) return {};

    try {
      return JSON.parse(jsonEl.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function isMadeToOrder(inventory) {
    return (
      inventory &&
      inventory.inventory_management === 'shopify' &&
      Number(inventory.inventory_quantity) <= 0
    );
  }

  function getVariantId(form) {
    var idInput = form.querySelector('[name="id"]');
    return idInput && idInput.value ? Number(idInput.value) : null;
  }

  function updateNotice(notice) {
    var form = notice.closest('form');
    if (!form) return;

    var variantId = getVariantId(form);
    var inventory = variantId ? getInventoryMap(form)[String(variantId)] : null;

    if (isMadeToOrder(inventory)) {
      notice.removeAttribute('hidden');
    } else {
      notice.setAttribute('hidden', '');
    }
  }

  function updateAllNotices() {
    document.querySelectorAll('[data-made-to-order-notice]').forEach(updateNotice);
  }

  function scheduleUpdate() {
    window.requestAnimationFrame(updateAllNotices);
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  document.addEventListener('flu:product:variant-change', scheduleUpdate);
  document.addEventListener('quickview:loaded', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'id') {
      scheduleUpdate();
    }
  });
})();
